// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1ebfb752] .orange-icon {\r\n  font-size: 18pt;\n}\n.my-pill-theme[data-v-1ebfb752] .service-pill {\r\n  --icon-bg: #3f5b60;\r\n  --icon-fg: #9faea7;\n}\r\n", ""]);
// Exports
module.exports = exports;
